/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Component, ViewEncapsulation, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MdSnackBarRef} from './snack-bar-ref';
import {MD_SNACK_BAR_DATA} from './snack-bar-config';
/**
 * A component used to open as the default snack bar, matching material spec.
 * This should only be used internally by the snack bar service.
 */
export class SimpleSnackBar {
/**
 * Data that was injected into the snack bar.
 */
data: { message: string, action: string };
/**
 * @param {?} snackBarRef
 * @param {?} data
 */
constructor(
public snackBarRef: MdSnackBarRef<SimpleSnackBar>,
     data: any) {
    this.data = data;
  }
/**
 * Performs the action on the snack bar.
 * @return {?}
 */
action(): void {
    this.snackBarRef.closeWithAction();
  }
/**
 * If the action button should be shown.
 * @return {?}
 */
get hasAction(): boolean {
    return !!this.data.action;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'simple-snack-bar',
  templateUrl: 'simple-snack-bar.html',
  styleUrls: ['simple-snack-bar.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'mat-simple-snackbar',
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdSnackBarRef, },
{type: undefined, decorators: [{ type: Inject, args: [MD_SNACK_BAR_DATA, ] }, ]},
];
}

function SimpleSnackBar_tsickle_Closure_declarations() {
/** @type {?} */
SimpleSnackBar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SimpleSnackBar.ctorParameters;
/**
 * Data that was injected into the snack bar.
 * @type {?}
 */
SimpleSnackBar.prototype.data;
/** @type {?} */
SimpleSnackBar.prototype.snackBarRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
